// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".centerContent {\n  text-align: center;\n  margin: auto;\n  display: block;\n  margin: 0 auto;\n  padding: 1.5rem;\n}\n\n.tw-main-div {\n  margin-left: 15px;\n  margin-right: 15px;\n  margin-bottom: 15px;\n  width: auto;\n  padding: 1.5rem;\n}\n\n.twitter-component {\n  width: auto;\n  padding: 1.5rem;\n}\n\n.timeline-Header-title {\n  font-size: 56px;\n  font-weight: 100 !important;\n}", ""]);
// Exports
module.exports = exports;
